import PropTypes from "prop-types";
import { useState } from "react";
import VisualEditorLayout from "../../../components/VisualEditorLayout";
import CanvasEditorPane from "./CanvasEditorPane";
import CanvasPreviewPane from "./CanvasPreviewPane";

export default function StepCanvas({
	formData,
	setFormData,
	sections,
	addSection,
	updateSection,
	removeSection,
	moveSection,
	duplicateSection,
	companies,
	selectedItems,
	showNotification,
}) {
	const [activeSectionIndex, setActiveSectionIndex] = useState(null);

	const selectedCompany = companies.find(
		(c) => String(c.id) === String(formData.company_id),
	);
	const previewCompany = {
		name: selectedCompany?.name || "Empresa",
		tagline: selectedCompany?.tagline || "",
		description: selectedCompany?.description || "",
	};

	const editorPane = (
		<CanvasEditorPane
			activeSectionIndex={activeSectionIndex}
			setActiveSectionIndex={setActiveSectionIndex}
			sections={sections}
			formData={formData}
			setFormData={setFormData}
			addSection={addSection}
			updateSection={updateSection}
			removeSection={removeSection}
			moveSection={moveSection}
			duplicateSection={duplicateSection}
			showNotification={showNotification}
		/>
	);

	const previewPane = (
		<CanvasPreviewPane
			activeSectionIndex={activeSectionIndex}
			setActiveSectionIndex={setActiveSectionIndex}
			sections={sections}
			updateSection={updateSection}
			selectedItems={selectedItems}
			previewCompany={previewCompany}
		/>
	);

	return (
		<div className="bg-slate-950 border border-white/5 rounded-xl overflow-hidden shadow-2xl">
			<VisualEditorLayout
				editor={editorPane}
				preview={previewPane}
				layout="builder"
			/>
		</div>
	);
}

StepCanvas.propTypes = {
	formData: PropTypes.object.isRequired,
	setFormData: PropTypes.func.isRequired,
	sections: PropTypes.array.isRequired,
	addSection: PropTypes.func.isRequired,
	updateSection: PropTypes.func.isRequired,
	removeSection: PropTypes.func.isRequired,
	moveSection: PropTypes.func.isRequired,
	duplicateSection: PropTypes.func.isRequired,
	companies: PropTypes.array.isRequired,
	selectedItems: PropTypes.array.isRequired,
	showNotification: PropTypes.func.isRequired,
};
